<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Helper from '@/helpers/helper';

/**
 * Dashboard Component
 */
export default {
    page: {
    title: "Utilisateurs",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Utilisateurs",
      items: [
        {
          text: "Menu",
          href: "/",
        },
        {
          text: "Utilisateurs",
          active: true,
        },
        {
          text: "Un utilisateur",
          active: true,
        },
      ],
      agent: {},
      id: "",
    };
  },
  methods: {
    toDate(date) {
      return Helper.toDate(date) 
    },
    getItem() {
      fetch(Helper.route('agents/'+this.id), Helper.requestOptions())
      .then(response => {
          Helper.tokenChecker(response.status)
          return response.json()
      })
      .then(data => {

        console.log(data);
      
        
        this.agent = data
      })
    },
  },
  mounted() {
    this.id = this.$route.params.id
    this.getItem()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    
    <div class="row" v-if="agent.id">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">À propos de l'utilisateur</h4>
            <div class="row">
              <div class="col-lg-3 mx-auto">
                <img :src="agent?.user?.profile" :alt="agent?.user.lastName" style="height: 120px; width: 120px" class="border rounded-circle">
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-3">
                <dl>
                  <dt>Nom de Famille</dt>
                  <dd>{{ agent?.user?.lastName }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Prénom(s)</dt>
                  <dd>{{ agent?.user?.firstName }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Sexe</dt>
                  <dd>{{ agent?.user?.gender == true ? "Masculin" : "Féminin" }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Email</dt>
                  <dd>{{ agent?.user?.email }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Code</dt>
                  <dd>{{ agent?.user?.code }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Pays</dt>
                  <dd>{{ agent?.user?.country?.name_fr ?? "Non definie"}}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Ville</dt>
                  <dd>{{ agent?.user?.city ?? "Non definie" }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Statut</dt>
                  <dd>
                    <button class="badge badge-pill badge-soft-success border-0 py-1 px-3" v-if="agent.status == 'active'">ACTIF</button>
                    <button class="badge badge-pill badge-soft-danger border-0 py-1 px-3" v-else>{{ agent.status }}</button>
                  </dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Role</dt>
                  <dd>{{ agent?.user?.roles[0] }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Date d'inscription</dt>
                  <dd>{{ toDate(agent.createdAt) }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>IP</dt>
                  <dd>{{ agent.ip }}</dd>
                </dl>
              </div>

              <div class="col-md-3">
                <dl>
                  <dt>Devise</dt>
                  <dd>{{ agent.devise }}</dd>
                </dl>
              </div>


            </div>


          </div>
        </div>

        
        <div class="card mt-3">
          <div class="card-body">
            <h4 class="card-title">Details</h4>
            <div class="row mt-4">
              <div class="col-md-3">
                <dl>
                  <dt>Balance</dt>
                  <dd>{{ agent?.balance }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Capital</dt>
                  <dd>{{ agent?.capital }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Deposit</dt>
                  <dd>{{ agent?.deposit }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Sum Deposit</dt>
                  <dd>{{ agent?.sumDeposit }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Gain</dt>
                  <dd>{{ agent?.gain }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Receiving</dt>
                  <dd>{{ agent?.receiving }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Sending</dt>
                  <dd>{{ agent?.sending }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Withdraw</dt>
                  <dd>{{ agent?.withdraw }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Sum Withdraw</dt>
                  <dd>{{ agent?.sumWithdraw }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Statut</dt>
                  <dd>
                    <button class="badge badge-pill badge-soft-success border-0 py-1 px-3" v-if="agent.status == 'active'">ACTIF</button>
                    <button class="badge badge-pill badge-soft-danger border-0 py-1 px-3" v-else>{{ agent.status }}</button>
                  </dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Topics</dt>
                  <dd>{{ agent?.topics }}</dd>
                </dl>
              </div>
              <div class="col-md-3">
                <dl>
                  <dt>Date d'inscription</dt>
                  <dd>{{ toDate(agent.createdAt) }}</dd>
                </dl>
              </div>
            </div>


          </div>
        </div>

      </div>
    </div>


  </Layout>
</template>
